import {
	FormControl,
	FormGroup,
	UntypedFormControl,
	Validators,
} from '@angular/forms';
import { BaseResponse } from './base-response.model';
import {
	CallingTreeMember,
	CallingTreeMemberJSON,
} from './calling-tree-member.model';

export interface NumberOfBranchesResponse extends BaseResponse {
	message: string;
	numberOfBranches: number;
}

export interface CallingTreeBranchResponse extends BaseResponse {
	message: string;
	callingTree: CallingTreeJSON;
}

export interface CallingTreeMembersResponse extends BaseResponse {
	message: string;
	members: CallingTreeMemberJSON[];
}

export interface CallingTreeJSON {
	branch: number;
	superCoordinatorId: number;
	superCoordinator: string;
	activeCoordinatorId: number;
	activeCoordinator: string;
	backupCoordinatorId: number;
	backupCoordinator: string;
	members: CallingTreeMemberJSON[];
}

export interface CoordinatorFormGroup {
	branch: FormControl<number>;
	activeCoordinatorId: FormControl<number>;
	backupCoordinatorId: FormControl<number>;
}

export class CallingTree {
	constructor(
		public branch: number,
		public superCoordinatorId: number,
		public superCoordinator: string,
		public activeCoordinatorId: number,
		public activeCoordinator: string,
		public backupCoordinatorId: number,
		public backupCoordinator: string,
		public members: CallingTreeMember[]
	) {}

	static fromJSON(json: CallingTreeJSON): CallingTree {
		return Object.assign(Object.create(CallingTree.prototype), json, {
			members: json.members
				? json.members.map((member) =>
						CallingTreeMember.fromJSON(member)
					)
				: [],
		});
	}

	static createCoordinatorFormGroup(): FormGroup<CoordinatorFormGroup> {
		return new FormGroup<CoordinatorFormGroup>({
			branch: new UntypedFormControl(null),
			activeCoordinatorId: new UntypedFormControl(null, [
				Validators.required,
			]),
			backupCoordinatorId: new UntypedFormControl(null, [
				Validators.required,
			]),
		});
	}

	static fromCoordinatorFormGroup(
		fg: FormGroup<CoordinatorFormGroup>
	): CallingTree {
		return Object.assign(Object.create(CallingTree.prototype), {
			branch: fg.value.branch,
			activeCoordinatorId: fg.value.activeCoordinatorId,
			backupCoordinatorId: fg.value.backupCoordinatorId,
		});
	}
}
